import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { customStyleSelect } from "utils/common";
import { activeStatusOptions, statusOptions } from "utils/constants";
import useUploadHook from "components/uploadHook";
import FilterSelect from "components/Form/filterSelect";
import { toast, Bounce } from "react-toastify";
import {Switch} from "antd";

import { useSelector } from "react-redux";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Button } from "components/Button";
import { format } from "date-fns";
import { Modal } from "antd";
import { createAssetMasterApi, updateAssetApi } from "api/services/assets";
import EssFullWidthModal from "components/modelpopup/baseModal";
import { useDropzone } from 'react-dropzone';

import ViewAssetAttachments from "views/pages/Assets/assetDetail/attachmentHandler";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import DateInput from "components/Form/dateInput";

const AllAssetAddPopup = ({
  createDocumentHandler,
  assetModal,
  setAssetModal,
  loading,
  selectedAsset,
  setLoading,
  setSelectedAsset,
  getAssetList,
  assetCategory
}) => {
  const modalRef = useRef();
  const [setSelectedOption] = useState(null);
  const [setSelectedOptionTwo] = useState(null);
  const [setSelectedOptionThree] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateTwo, setSelectedDateTwo] = useState(null);

  const [documentSubTypeOption, setDocumentSubTypeOption] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const {
    user,
    userLoading
  } = useSelector((state) => state.user);

  const [documentTypeOption, setDocumentTypeOption] = useState([
    {
      label: "User",
      value: "user",
    },
  ]);

  const [fileUploadLoading, setFileUploadLoading] = useState(false);

  const {
    documentSubType,
    documentSubTypeLoading,

    userData,
    userDataLoading,
  } = useSelector((state) => state.common);

  const { uploadLoading, handleFile } = useUploadHook();

  const jobRequestSchema = Yup.object().shape({
    name: Yup.string().required("Asset name is required"),
    description: Yup.string().nullable().notRequired(), // Allows empty, null, or undefined
    class_code: Yup.string().nullable().notRequired(), // Allows empty, null, or undefined
    ext_id: Yup.string().nullable().notRequired(), // Allows empty, null, or undefined
    // code: Yup.string().required("Code is required"),

    purchase_date: Yup.date().required("Purchase date is required"),
    // return_date: Yup.string(),
    // updated_date: Yup.string(),
    // company_user: Yup.object().required("User is required"),
    status: Yup.boolean().required("Status is required"),
    purchase_value: Yup.number().required("Purchase value is required"),
    // current_value: Yup.number().required("Current value is required"),
    brand: Yup.string().nullable().notRequired(), // Allows empty, null, or undefined,
    serial_number: Yup.string().required("Serial number  is required"),
    image: Yup.string().required("Image is required"),
    category: Yup.object().required("Category is required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
    setError,
    reset,
    register,
  } = useForm({
    resolver: yupResolver(jobRequestSchema),
    defaultValues: {
      status: true,
    },
  });


  // const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
  //   control, // control props comes from useForm (optional: if you are using FormProvider)
  //   name: "attachments", // unique name for your Field Array
  // });

  useEffect(() => {
    if (documentSubType) {
      let sub_types = documentSubType.map((item) => {
        return {
          label: item.display_name,
          value: item.name,
        };
      });
      setDocumentSubTypeOption(sub_types);
    }
  }, [documentSubType]);

  useEffect(() => {
    if (userData) {
      let users = userData.map((item) => {
        return {
          label: `${item.first_name} ${item.last_name}`,
          value: item.id,
        };
      });
      setUserOption(users);
      
    }
  }, [userData]);

  useEffect(() => {
  
  
   
    if (selectedAsset?.id) {
      const values = getValues();
    const fieldNames = Object.keys(values);
    console.log("Field Names:", fieldNames);
    fieldNames.push("image")

    fieldNames.forEach(item=>{
              // setValue(item, selectedAsset[item])

      if(item == "category"){
        const selected = assetCategory.find(item=> item.id == selectedAsset?.category?.id)
        setValue(item, selected)
      }else{
        setValue(item, selectedAsset[item])
        console.log(item, selectedAsset[item])
      }
    })  
   
    // setValue("image", selectedAsset?.image)

      // setValue("name", selectedAsset?.name);
      // setValue("description", selectedAsset?.description);
      // setValue(
      //   "image",
      //   selectedAsset?.attachments?.map((item) => {
      //     return {
      //       // id: item.id,
      //       item_id: item.id,
      //       url: item.url,
      //     };
      //   })
      // );

      // // if (selectedAsset?.company_user) {
      // //   setValue(
      // //     "company_user",
      // //     userOption.find(
      // //       (item) => item.value == selectedAsset?.company_user?.id
      // //     )
      // //   );
      // // }
      // if (selectedAsset?.document_sub_type) {
      //   console.log(
      //     selectedAsset?.department?.id,
      //     documentSubTypeOption,
      //     "JJJJJJJJJJJJJJJJ"
      //   );
      //   setValue(
      //     "document_sub_type",
      //     documentSubTypeOption.find(
      //       (item) => item.value == selectedAsset?.document_sub_type
      //     )
      //   );
      // }

      // if (selectedAsset?.document_type) {
      //   console.log(
      //     selectedAsset?.department?.id,
      //     documentSubTypeOption,
      //     "JJJJJJJJJJJJJJJJ"
      //   );
      //   setValue(
      //     "document_type",
      //     documentTypeOption.find(
      //       (item) => item.value == selectedAsset?.document_type
      //     )
      //   );
      // }
      // if (selectedAsset?.status) {
      //   setValue("status", selectedAsset?.status);
      //   // setValue("status", statusOptions.find(item=> item.value == selectedAsset?.status.toLowerCase()))
      // }

      // setValue("expiry_date", selectedAsset?.expiry_date || "");
      // setValue("issue_date", selectedAsset?.issue_date || "");

      // setValue("application_count", selectedAsset?.application_count)
    } else {
      setValue("status", true);
    }
    
  }, [selectedAsset, assetModal, documentSubTypeOption, userOption, assetCategory]);

  const [selectedIssueDate, setSelectedIssueDate] = useState(null);
  const [selectedExpiryDate, setSelectedExpiryDate] = useState(null);

  const handleIssueDateChange = (date) => {
    setSelectedIssueDate(date);
  };

  const handleExpiryDateChange = (date) => {
    setSelectedExpiryDate(date);
  };

  const fileUploadHandler = async (acceptedFiles , rejectedFiles , e ) => {
    console.log(e.target.files, "EEEE");
    let attachments = [];
    const urls = await handleFile(e);
    if (Array.isArray(urls)) {
      // attachments = urls.map((item) => {
      //   return { url: item };
      // });
      urls = urls[0]
    } else {
      // attachments.push({
      //   url: urls,
      // });
    }
    // console.log(fields, "LLLL");

    setValue("image", urls);
  };
       // Use Dropzone hook
       const { getRootProps, getInputProps } = useDropzone({
        onDrop: fileUploadHandler,
  
        accept: 'image/*', // Accept image, PDF, DOCX
      });
    

  const onSubmit = (fd) => {

    let data = {...fd}
    // data["company_user"] = data?.company_user?.value;
    data["category"] = data?.category?.id;
    console.log(data, "DDDD")

    // let attachments_data = data["attachments"].map((item) => {
    //   return {
    //     id: item.item_id || "",
    //     url: item.url,
    //   };
    // });
    // data["attachments"] = attachments_data;

    // if (data.return_date) {
    //   data["return_date"] = format(new Date(data.return_date), "yyyy-MM-dd");
    // }
    // if (data.issue_date) {
    //   data["issue_date"] = format(new Date(data.issue_date), "yyyy-MM-dd");
    // }

    // if (data.issue_date) {
    //   data["updated_date"] = format(new Date(data.updated_date), "yyyy-MM-dd");
    // }

    if(data.purchase_date){
      data["purchase_date"] = format(new Date(data.purchase_date), "yyyy-MM-dd");
    }
    setLoading(true);

    if(selectedAsset?.id){
      updateAssetApi(selectedAsset?.id, data).then(response=>{
        setLoading(false)

        toast.success('Asset updated!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          setAssetModal(false)
          setSelectedAsset("")
          reset()

        console.log(response, "REEEEEE")
      }).catch(e=> {
        setLoading(false)

        try{
          console.log(e.response.data, "EEEEE")
          if(e.response.data){
            Object.entries(e.response.data).forEach(([k, v]) => {
              console.log(typeof v, "EEEEE")
              setError(k,
                {
                  type: 'manual',
                  message: v.join(", ")
                }
                 )
            })
          }
        }catch(e){
          let commonError = e.response?.data?.error || 'Failed to update asset!'

          toast.error(commonError, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }

      })

    }else{
      data["status"] = true
      createAssetMasterApi(data).then(response=>{
        setLoading(false)

        toast.success('Asset created!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          setAssetModal(false)
          setSelectedAsset("")
          reset()
          getAssetList()

        console.log(response, "REEEEEE")
      }).catch(e=> {
        setLoading(false)

        try{
          console.log(e.response.data, "EEEEE")
          if(e.response.data){
            Object.entries(e.response.data).forEach(([k, v]) => {
              console.log(typeof v, "EEEEE")
              setError(k,
                {
                  type: 'manual',
                  message: v.join(", ")
                }
                 )
            })
          }
        }catch(e){
          let commonError = e.response?.data?.error || 'Failed to create asset!'
          toast.error(commonError, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }

      })
    }
  };

  const image = watch('image')

  const status = watch('status')
  
  return (
    <>
      <div role="dialog">
        <EssFullWidthModal
          mask={false}
          title={selectedAsset?.id ? "Update Asset" : ""}
          // style={{ top: 100 }}
          open={assetModal}
          width={"40%"}
          footer={[]}
          onCancel={() => {
            setAssetModal(false);
            setSelectedAsset("");
          }}
          className="full-width-modal"
        >
          <div className="modal-content">
            <div className="modal-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  {/* Asset Name */}
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Asset Name</label>
                      <Controller
                        name="name"
                        control={control}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            placeholder="Asset Name"
                          />
                        )}
                      />
                      {errors.name && (
                        <small className="text-danger">
                          {errors.name?.message}
                        </small>
                      )}
                    </div>
                  </div>
                  {/* Description */}
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Description</label>
                      <Controller
                        name="description"
                        control={control}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            placeholder="Description"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* Issue Date */}
                  {/* <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Code</label>
                      <Controller
                        name="code"
                        control={control}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            placeholder="Code"
                          />
                        )}
                      />

                      {errors.code && (
                        <small className="text-danger">
                          {errors.code?.message}
                        </small>
                      )}
                    </div>
                  </div> */}

                  {/* Select User */}
                  {/* <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">User</label>
                      <Controller
                        name={`company_user`}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <FilterSelect
                              {...register("company_user")}
                              isClearable={true}
                              onChange={onChange}
                              optionLabel={"label"}
                              optionValue={"value"}
                              options={userOption}
                              isLoading={userDataLoading}
                              value={value}
                              placeholder={"Company user"}
                            />
                          </>
                        )}
                      />
                      {console.log(errors, "EEEEEEEE")}
                      {errors.company_user && (
                        <small className="text-danger">
                          {errors.company_user?.message}
                        </small>
                      )}
                    </div>
                  </div> */}

                  {/* Issue Date */}
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Purchase Date</label>
                      <Controller
                        name="purchase_date"
                        control={control}
                        render={({ field }) => (
                          <DateInput
                            className="form-control floating datetimepicker "
                            selected={field?.value}
                            onChange={field.onChange}
                            dateFormat="dd-MM-yyyy"
                          />
                        )}
                      />
                      {errors.purchase_date && (
                        <small className="text-danger">
                          {errors.purchase_date?.message}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Return Date */}
                  {/* <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Return Date</label>
                      <Controller
                        name="return_date"
                        control={control}
                        render={({ field }) => (
                          <DatePicker
                            className="form-control floating datetimepicker "
                            selected={field?.value}
                            onChange={field.onChange}
                            dateFormat="dd-MM-yyyy"
                          />
                        )}
                      />
                      {errors.return_date && (
                        <small className="text-danger">
                          {errors.return_date?.message}
                        </small>
                      )}
                    </div>
                  </div> */}

                  {/* Updated Date */}
                  {/* <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Updated Date</label>
                      <Controller
                        name="updated_date"
                        control={control}
                        render={({ field }) => (
                          <DatePicker
                            className="form-control floating datetimepicker "
                            selected={field?.value}
                            onChange={field.onChange}
                            dateFormat="dd-MM-yyyy"
                          />
                        )}
                      />
                      {errors.updated_date && (
                        <small className="text-danger">
                          {errors.updated_date?.message}
                        </small>
                      )}
                    </div>
                  </div> */}

                  {/* Comments */}
                  {/* <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Comments</label>
                      <Controller
                        name="comments"
                        control={control}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            placeholder="Comments"
                          />
                        )}
                      />
                    </div>
                  </div> */}

                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">FA No </label>
                      <Controller
                        name="ext_id"
                        control={control}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            placeholder="FA No"
                          />
                        )}
                      />

                      {errors.ext_id && (
                        <small className="text-danger">
                          {errors.ext_id?.message}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">FA Class Code</label>
                      <Controller
                        name="class_code"
                        control={control}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            placeholder="Class Code"
                          />
                        )}
                      />

                      {errors.class_code && (
                        <small className="text-danger">
                          {errors.class_code?.message}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Purchase value</label>
                      <Controller
                        name="purchase_value"
                        control={control}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            placeholder="Purchase value"
                          />
                        )}
                      />

                      {errors.purchase_value && (
                        <small className="text-danger">
                          {errors.purchase_value?.message}
                        </small>
                      )}
                    </div>
                  </div>


                  {/* <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Current value</label>
                      <Controller
                        name="current_value"
                        control={control}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            placeholder="Current value"
                          />
                        )}
                      />

                      {errors.current_value && (
                        <small className="text-danger">
                          {errors.current_value?.message}
                        </small>
                      )}
                    </div>
                  </div> */}


                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Brand</label>
                      <Controller
                        name="brand"
                        control={control}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            placeholder="Brand"
                          />
                        )}
                      />

                      {errors.brand && (
                        <small className="text-danger">
                          {errors.brand?.message}
                        </small>
                      )}
                    </div>
                  </div>


                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Serial Number</label>
                      <Controller
                        name="serial_number"
                        control={control}
                        render={({ field }) => (
                          <input
                            className="form-control"
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            type="text"
                            placeholder="Model Number"
                          />
                        )}
                      />

                      {errors.serial_number && (
                        <small className="text-danger">
                          {errors.serial_number?.message}
                        </small>
                      )}
                    </div>
                  </div>


                  <div className="col-md-6">
                  <div className="input-block mb-3">
                      <label className="col-form-label">Asset Category</label>
                      <Controller
                         name={`category`}                   
                         control={control}                  
                         render={({ field: { value, onChange } }) => (
                          <>
                          <FilterSelect
                        {...register("category")}
                        isClearable={true}
                        onChange={onChange}
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={assetCategory}
                        isLoading={false}
                        value={value}
                        placeholder={"Asset Category"}
                      />                       
                      </>
                    )}
                  />
                 
                  {errors.category && <small className="text-danger">{errors.category?.message}</small>}                     
                  </div>
                  </div>
                  {
                    selectedAsset?.id  && (
                      <div className="col-md-6">
                      <div className="input-block mb-3">
                      <label className="col-form-label">
                     Status 
                  </label>
                  <Controller
                          name="status"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <div className="d-flex align-items-center">
                              <Switch 
                                checked={value} 
                                onChange={onChange} 
                                onColor="#0d6efd" 
                                offColor="#ccc"
                                // checkedIcon={<div style={{ padding: 5 }}>Active</div>}
                                // uncheckedIcon={<div style={{ padding: 5 }}>Inactive</div>}
                              />
                              {/* <span className="ms-2">{value ? "Active" : "Inactive"}</span> */}
                            </div>
                          )}
                        />
                 
                      <br/>
                      </div>
                    </div>
                    )
                      
                  }
                 
                </div>

                {/* Attachments */}
            
                <div className="row">
                  <div className="col-md-6">
                  <div className="input-block mb-3">

                  <label className="col-form-label">Image {
                    uploadLoading && <i class="fa fa-spinner fa-spin" ></i>
                  }</label>
                  
                    
                    <div
                      {...getRootProps({ className: 'dropzone' })}
                      style={{
                        border: '2px dashed #000',
                        padding: '20px',
                        textAlign: 'center',
                      }}
                    >
                      <input {...getInputProps()} />
                      <p>Drag & Drop your files here, or click to select files</p>
                    </div>

                  {/* <input
                    type="file"
                    className="form-control"
                    id="cv_upload"
                    // accept=".png, .jpg, .jpeg"
                    onChange={fileUploadHandler}
                    disabled={uploadLoading}
                    multiple
                  /> */}
                  <p className="text-danger mb-2">
                    {errors?.image?.message}
                  </p>
                  
                </div>           
                  </div>
                   


                  
                </div>

                <div className="col-12">
                      <ViewAssetAttachments fields={image ? [{url:image}] : []} remove={()=> setValue("image", "")} />
                  </div>
                <div className="submit-section">
                  <Button
                    loading={loading}
                    disabled={loading || uploadLoading}
                    className="btn btn-primary submit-btn"
                    type="submit"
                    label="Submit"
                  />
                </div>
              </form>
            </div>
          </div>
        </EssFullWidthModal>
      </div>
    </>
  );
};

export default AllAssetAddPopup;
